import { render } from "./PaymentSlipWorkDialog.vue?vue&type=template&id=0b4e35d8&scoped=true"
import script from "./PaymentSlipWorkDialog.vue?vue&type=script&lang=ts"
export * from "./PaymentSlipWorkDialog.vue?vue&type=script&lang=ts"

import "./PaymentSlipWorkDialog.vue?vue&type=style&index=0&id=0b4e35d8&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-0b4e35d8"

export default script